import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "messages", "attachmentNames"]
  static values = { readUrl: String }

  connect() {
    this.boundOnStreamRender = () => {
      requestAnimationFrame(() => {
        this.scrollToBottom()
        this.clearTextarea()
      })
    }
    document.addEventListener("turbo:before-stream-render", this.boundOnStreamRender)

    const params = new URLSearchParams(window.location.search)
    if (params.get("open_thread") === "true") {
      this.open()
      const messageId = params.get("highlight_message")
      if (messageId) {
        requestAnimationFrame(() => this.highlightAndScroll(messageId))
      }
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundOnStreamRender)
  }

  open() {
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-x-full")
    requestAnimationFrame(() => this.scrollToBottom())
    this.markAsRead()
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("hidden")
  }

  scrollToBottom() {
    const el = this.messagesTarget
    el.scrollTop = el.scrollHeight
  }

  highlightAndScroll(messageId) {
    const el = document.getElementById(`message-${messageId}`)
    if (!el) return
    el.classList.add("ring-2", "ring-yellow-400", "rounded")
    el.scrollIntoView({ block: "center" })
  }

  autoGrow(event) {
    const textarea = event.target
    textarea.style.height = "auto"
    textarea.style.height = textarea.scrollHeight + "px"
  }

  showAttachments(event) {
    const files = event.target.files
    if (!this.hasAttachmentNamesTarget) return
    if (files.length === 0) {
      this.attachmentNamesTarget.textContent = ""
    } else if (files.length === 1) {
      this.attachmentNamesTarget.textContent = files[0].name
    } else {
      this.attachmentNamesTarget.textContent = `${files.length} files selected`
    }
  }

  clearTextarea() {
    const textarea = this.element.querySelector("textarea[name='message[body]']")
    if (textarea) {
      textarea.value = ""
      textarea.style.height = ""
    }
  }

  markAsRead() {
    if (!this.hasReadUrlValue || !this.readUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    if (!csrfToken) return

    fetch(this.readUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken.content,
        "Accept": "application/json"
      }
    })
  }
}
